import React from "react";
import SubCategory from "./subCategory";
import { Box, Container, LinearProgress, Typography } from "@mui/material";
import { getScoreColor } from "./../utils/helpers";

const Category = ({ category }) => {
  return (
    <Box sx={{ py: 6 }}>
      <Container maxWidth="lg">
        <Box sx={{ display: "flex", alignItems: "center", mb: 4 , justifyContent: "space-between"}}>
          <Typography
            variant="h3"
            component="h1"
            sx={{fontWeight: "bold"}}
          >
            {category.category_name}
          </Typography>
          <Typography
            variant="h4"
            component="h1"
            sx={{
              color: getScoreColor(category.category_score),
              fontSize: "28px",
            }}
          >
            {category.category_score}%
          </Typography>
        </Box>
        <Box sx={{ mb: 6 }}>
          <LinearProgress
            variant="determinate"
            value={category.category_score}
            sx={{
              height: 8,
              borderRadius: 4,
              "& .MuiLinearProgress-bar": {
                background: getScoreColor(category.category_score),
                borderRadius: 4,
              },
            }}
          />
        </Box>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          {category.description}
        </Typography>

        {category.guidelines.map((subCategory, index) => (
          <>
            <SubCategory subCategory={subCategory} />
            {index < category.guidelines.length - 1 && (
              <Box sx={{ my: 4, borderBottom: "1px solid #e0e0e0" }} />
            )}
          </>
        ))}
      </Container>
    </Box>
  );
};

export default Category;
